import {UsersState} from './states/users.state';

export const usersStates = [
    UsersState
];
